<main class="main-container">
    <div class="row paragraph mt-3">
        <div class="col-12 heading-2">
            Step 2: Work-Related Information
        </div>
    </div>
    <form [formGroup]="companyInfoForm" (ngSubmit)="onSubmit()">
        <div *ngIf="!isPrincipal">
            <div class="row paragraph mt-5">
                <div class="col-12 bold">
                    Confirm the following details <span class="coral-text">of your principal</span>:
                </div>
                <div class="col-12 mt-2">
                    Please note: if the information below is incorrect, the link used to register is not generated by
                    your principal.
                </div>
            </div>
            <div class="row paragraph mt-4">
                <div class="col-4">
                    <label for="principalName">Name:</label>
                </div>
                <div class="col-8">
                    <input required id="principalName" formControlName="principalName" type="text">
                </div>
            </div>
            <div class="row paragraph mt-3">
                <div class="col-4">
                    <label for="principalSurname">Surname:</label>
                </div>
                <div class="col-8">
                    <input required id="principalSurname" formControlName="principalSurname" type="text">
                </div>
            </div>
            <div class="row paragraph mt-3">
                <div class="col-4">
                    <label for="principalIdNumber">ID/passport number:</label>
                </div>
                <div class="col-8">
                    <input required id="principalIdNumber" formControlName="principalIdNumber" type="text">
                </div>
            </div>
        </div>
        <div *ngIf="isPrincipal">
            <div class="row paragraph mt-5">
                <div class="bold">
                    Please select:
                </div>
            </div>
            <div class="row paragraph mt-3">
                <mat-radio-group formControlName="isAffiliatedWithAgency" class="d-flex flex-column">
                    <mat-radio-button class="mt-1" [value]="true">
                        I am affiliated with a franchised estate agency
                    </mat-radio-button>
                    <mat-radio-button class="mt-1" [value]="false">
                        I am an independent estate agent/business, not linked to any franchise
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div *ngIf="isAffiliatedWithAgency">
                <div class="row paragraph mt-3">
                    <div class="col-4">
                        <label for="agencyName">Name of the agency</label>
                    </div>
                    <div class="col-8">
                        <input required id="agencyName" formControlName="agencyName" type="text">
                    </div>
                </div>
                <div class="row paragraph mt-3">
                    <div class="col-4">
                        <label for="agencyBranch">Name of the branch you are operating from</label>
                    </div>
                    <div class="col-8">
                        <input required id="agencyBranch" formControlName="agencyBranch" type="text">
                    </div>
                </div>
            </div>
            <div *ngIf="!isAffiliatedWithAgency">
                <div class="row paragraph mt-3">
                    <div class="col-4">
                        <label for="firmName">Firm name</label>
                    </div>
                    <div class="col-8">
                        <input required id="firmName" formControlName="firmName" type="text">
                    </div>
                </div>
                <div class="row paragraph mt-3">
                    <div class="col-4">
                        <label for="tradingName">Trading name</label>
                    </div>
                    <div class="col-8">
                        <input required id="tradingName" formControlName="tradingName" type="text">
                    </div>
                </div>
            </div>
            <div class="row paragraph mt-5">
                <div class="bold">
                    Physical address of your office:
                </div>
            </div>
            <div class="row paragraph mt-3">
                <div class="col-4">
                    <label for="streetNumber">Building / Floor / Unit</label>
                </div>
                <div class="col-8">
                    <input required id="streetNumber" formControlName="streetNumber" type="text">
                </div>
            </div>
            <div class="row paragraph mt-3">
                <div class="col-4">
                    <label for="streetName">Street address</label>
                </div>
                <div class="col-8">
                    <input required id="streetName" formControlName="streetName" type="text">
                </div>
            </div>
        </div>
        <div class="row paragraph mt-5">
            <div class="text-center">
                <button class="button" type="submit" [disabled]="companyInfoForm.invalid">SUBMIT</button>
            </div>
        </div>
    </form>
</main>